import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom'

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";
import ExpoRichiesteStepper from "pages/riservata/expo_richieste/ExpoRichiesteStepper"

import FormControl from "@mui/material/FormControl";
import FormControlLabel from '@mui/material/FormControlLabel';
import NativeSelect from '@mui/material/NativeSelect';
import InputLabel from '@mui/material/InputLabel';
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import Card from "@mui/material/Card";
import Checkbox from '@mui/material/Checkbox';

//pdf viewer
import { Worker } from '@react-pdf-viewer/core';
// Import the main component
import { Viewer, SpecialZoomLevel, ViewMode, ScrollMode } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

//script
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";

// Data
import UtilityService from "services/API/utility/UtilityService";
import MDTypography from "common/components/MD/MDTypography";
import { useMaterialUIController } from "common/context";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import { brandButtonOutlinedSx } from "common/assets/theme/components/brandButtonSx";





const ExpoRichiesteStart = () => {

  const navigate = useNavigate();

  const [controller, dispatch] = useFarFieraUIController();
  const { manifestazione } = controller;



  const [accettato, setAccettato] = useState(false);
  const [displayPDF, setDisplayPDF] = useState('stringa_iniziale');

  const defaultLayoutPluginInstance = defaultLayoutPlugin(

  );


  useEffect(() => {

    carica_pdf(manifestazione);
  
  }, [manifestazione]);
   

  const avanti = () => {

    //controllo se esiste già una richiesta 
    navigate("/expo_richiestaEdit1", { state: { modo: 'new', soggetto: null, subject: manifestazione } });

  }

  const handleChangeE = (event) => {
    setAccettato(event.target.checked);

  }

  const annulla = () => {
    navigate("/expo_richieste");
  }

  

  const carica_pdf = (nome_man) => {

    console.log('carica_pdf ' + nome_man);
   
    if (nome_man !== '') {

      UtilityService.seleziona_file_man(nome_man,"REGOLAMENTO")
        .then(response => {
          //  const filename =  response.headers.get('Content-Disposition').split('filename=')[1];
          var arrrayBuffer = base64ToArrayBuffer(response.data); //data is the base64 encoded string
          var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
          var url = URL.createObjectURL(blobb);

          setDisplayPDF(url);

        });
    }

  }



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3} px={3} spacing={6} >

        <Card>
          <HeaderForm titolo={"Proposta di Partecipazione " + manifestazione}  exit={annulla} modo='' save={annulla} subject="" />
          <MDBox pt={4} pb={3} px={3} >
            <MDBox>
              <ExpoRichiesteStepper index_attivo={0} />
            </MDBox>
            <MDBox>
              <MDBox pt={4} pb={3} px={3} >
                <FormControl fullWidth>
                  <MDTypography variant="h5" gutterBottom sx={({ palette: { brand } }) => ({ color: brand.main })} htmlFor="manifestazione" shrink={true} >Manifestazione : {manifestazione} </MDTypography>
                
                </FormControl>

              </MDBox>
              <MDBox >

                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js"  >
                  <div style={{ height: "720px" }}>
                    {displayPDF !== 'stringa_iniziale' &&
                      <Viewer plugins={[defaultLayoutPluginInstance]} fileUrl={displayPDF} defaultScale={SpecialZoomLevel.PageFit}
                        ScrollMode={ScrollMode.Page} ViewMode={ViewMode.SinglePage}
                        initialPage={0} />}
                  </div>
                </Worker>


              </MDBox>
              <MDBox>
                <FormControlLabel control={<Checkbox onChange={handleChangeE} />} label="Accetto i termini del regolamento" />
              </MDBox>

              <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                <MDBox sx={{ flex: '1 1 auto' }} />
 <MDButton  variant="contained" sx={brandButtonOutlinedSx } type="button"  onClick={avanti}  disabled={!accettato}>Avanti</MDButton>


              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
/*
AnagraficaExists.defaultProps = {
    subject: "ALL",
  
  };
  
  // Typechecking props for the Footer
  AnagraficaExists.propTypes = {
    subject: PropTypes.string,
   
  };*/

export default ExpoRichiesteStart;
